var $fd928d81cf33984c$exports = {};
$fd928d81cf33984c$exports = {
  "alert": "\u05D4\u05EA\u05E8\u05D0\u05D4",
  "dismiss": "\u05D4\u05EA\u05E2\u05DC\u05DD"
};
export { $fd928d81cf33984c$exports as default };